export const EVENT_NAMES = {
  HEALTHIERSG_HEALTHPLAN_TODO: 'hsg_healthplan_todo',
  HEALTHIERSG_HEALTHPLAN_SUMMARY: 'hsg_healthplan_summary',
  HEALTHIERSG_HEALTHPLAN_TOOLS: 'hsg_healthplan_tools',
  HEALTHIERSG_LIFESTYLE_PAGE: 'hsg_lifestyle_page',
  HEALTHIERSG_GENAI_PAGE: 'hsg_hpai_page',
  HEALTHIERSG_GENAI_ACTION: 'hsg_hpai_action',
  HH_NOTIFICATIONS: 'hh_notifications',
  MEMBER_PRN: 'memberPRN',
  USER_PRN: 'userPRN',
};

export const EVENT_ACTIONS = {
  EXERCISE_PLANNER: 'exercisePlanner',
  VIEW_DETAILS: 'viewDetails',
  CUSTOMIZE: 'customize',
  GENERATE_NEW_PLAN: 'generateNewPlan',
  VIEW_HEALTH_PLAN_SUMMARY: 'viewHealthPlanSummary',
  NOTIFY_HEALTHPLAN_READY: 'notify_healthplan_ready',
  THUMBSUP: 'thumbsUp',
  THUMBSDOWN: 'thumbsDown',
};

export const PAGE_STATE = {
  EXERCISE_PLAN: 'exercisePlan',
  RENEW_EXERCISE_PLAN: 'renewExercisePlan',
  EXERCISE_DETAILS: 'exerciseDetails',
  ACTIVITY_DETAILS: 'activityDetails',
  FEEDBACK: 'feedback',
};
